import React from "react";
import { CardContainer, Container, Interaction, TitleContainer } from "./DeviceSummaryStats.styles";
import UI from "@mile-meeting/mile-ui";
import ToolTip from "uis/new-tootip";

type DeviceSummaryStatsProps = {
  totalMeetingRoom: number;
  normalMeetingRoom: number;
  errorMeetingRoom: number;
};
const DeviceSummaryStats: React.FC<DeviceSummaryStatsProps> = ({
  totalMeetingRoom,
  normalMeetingRoom,
  errorMeetingRoom,
}) => {
  return (
    <Container>
      <CardContainer>
        <TitleContainer>
          <UI.Typography type="body02 normal" fontStyle="bold" color="var(--alias-color-label-alternative)">
            전체 회의실
          </UI.Typography>
          <ToolTip
            text={"태블릿 사용이 활성화된 회의실 전체 개수를 의미합니다."}
            position={{
              top: -30,
              left: -40,
            }}
            icon={<UI.Icon name="info" size={16} color="var(--alias-color-label-assistive)" />}
          />
        </TitleContainer>
        <UI.Typography type="heading01" fontStyle="bold" color="var(--alias-color-label-normal)">
          {totalMeetingRoom}
        </UI.Typography>
      </CardContainer>
      <CardContainer>
        <TitleContainer>
          <UI.Typography type="body02 normal" fontStyle="bold" color="var(--global-color-cyan-40)">
            정상 연동 회의실
          </UI.Typography>
          <ToolTip
            text={"연동 상태, 배터리/충전 상태가 정상인 회의실 개수를 의미합니다."}
            position={{
              top: -30,
              left: -40,
            }}
            icon={<UI.Icon name="info" size={16} color="var(--alias-color-label-assistive)" />}
          />
        </TitleContainer>
        <UI.Typography type="heading01" fontStyle="bold" color="var(--alias-color-label-normal)">
          {normalMeetingRoom}
        </UI.Typography>
      </CardContainer>
      <CardContainer>
        <TitleContainer>
          <UI.Typography type="body02 normal" fontStyle="bold" color="var(--global-color-red-70)">
            문제 발생 회의실
          </UI.Typography>
          <ToolTip
            text={"연동 상태, 배터리/충전 상태에 문제가 발생한 회의실 개수를 의미합니다."}
            position={{
              top: -30,
              left: -285,
            }}
            icon={<UI.Icon name="info" size={16} color="var(--alias-color-label-assistive)" />}
          />
        </TitleContainer>
        <UI.Typography type="heading01" fontStyle="bold" color="var(--alias-color-label-normal)">
          {errorMeetingRoom}
        </UI.Typography>
      </CardContainer>
    </Container>
  );
};

export default React.memo(DeviceSummaryStats);
